export default __webpack_public_path__ + "static/media/Team.6f920215.png";